import type { Moment } from 'moment'
import moment from 'moment'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'

interface Props {
  startDate: Moment | undefined
  endDate: Moment | undefined
  startTime: Moment | undefined
  endTime: Moment | undefined
  isAccommodation: boolean
}

const Dates = styled.div`
  display: flex;
  width: 100%;
`

const Date = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

function CheckInAndOutDate({
  startDate,
  endDate,
  startTime,
  endTime,
  isAccommodation,
}: Props) {
  const intl = useIntl()
  const timeFormat = useRegionTimeFormat()

  const checkInLabel = intl.formatMessage({
    id: 'e_outHjo1jis6mD5ANB8',
    defaultMessage: 'Check in',
    description: 'Label for accommodation check-in date in the date selection or calendar picker',
  })
  const startDateLabel = intl.formatMessage({
    id: 'HAX7gFEI97wG5T8xC5Ke',
    defaultMessage: 'Start date',
    description: 'Label for trip item start date in the trip planner feature',
  })
  const checkOutLabel = intl.formatMessage({
    id: '6JhKANt1mPbpuAi6_l11',
    defaultMessage: 'Check out',
    description: 'Label for accommodation check-out date in the date selection or calendar picker',
  })
  const endDateLabel = intl.formatMessage({
    id: '0HHvOYj4wB5e_TO2TZIJ',
    defaultMessage: 'End date',
    description: 'Label for the end date displayed on a trip itinerary item card',
  })

  return (
    <Dates>
      {startDate && moment(startDate).isValid() && (
        <Date>
          <BodyText variant="medium" weight="bold">
            {isAccommodation ? checkInLabel : startDateLabel}
          </BodyText>
          <BodyText variant="large">
            {startDate.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
          {startTime && (
            <BodyText variant="large">{startTime.format(timeFormat)}</BodyText>
          )}
        </Date>
      )}
      {endDate && moment(endDate).isValid() && (
        <Date>
          <BodyText variant="medium" weight="bold">
            {isAccommodation ? checkOutLabel : endDateLabel}
          </BodyText>
          <BodyText variant="large">
            {endDate.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
          {endTime && (
            <BodyText variant="large">{endTime.format(timeFormat)}</BodyText>
          )}
        </Date>
      )}
    </Dates>
  )
}

export default CheckInAndOutDate
